export default __webpack_public_path__ + "static/media/kitfranquia.62bd26d8.png";